<template>
  <div class="create-credentials">
    <credentials-details-with-async-fallback :handle-back="deletePageParams">
      <template v-slot:credentials>
        <credentials-details :invalid-credentials="invalidCredentials"
                             :source="source"
                             :name-already-used-error="nameAlreadyUsedError"
                             :set-name-already-in-use-error="setNameAlreadyInUseError"
                             :save-credentials-error="saveCredentialsError"
                             :on-save="saveCredentials"/>
      </template>
    </credentials-details-with-async-fallback>
  </div>
</template>

<script>
import CredentialsDetails from '@/base-components/onboarding/CredentialsDetails';
import CredentialsDetailsWithAsyncFallback
  from '@/pages/responsive-pages/authenticated/onboard2/CredentialsDetailsWithAsyncFallback';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ShowUnsupportedModalMixin from '../../../unsupported-banks/ShowUnsupportedModalMixin.vue';

export default {
  name: 'BankConnectionFlow',
  mixins: [ShowUnsupportedModalMixin],
  components: {
    CredentialsDetailsWithAsyncFallback,
    CredentialsDetails,
  },
  computed: {
    ...mapState('onboardingState', ['nameAlreadyUsedError', 'saveCredentialsError']),
    ...mapGetters('onboardingState', ['invalidCredentials', 'sourceName']),
    ...mapGetters('sourceFields', ['getSourceBySourceName']),
    source() {
      return this.getSourceBySourceName(this.sourceName);
    },
  },
  methods: {
    ...mapActions('onboardingState', ['saveCredentials', 'deletePageParams', 'deletePageParams']),
    ...mapMutations('onboardingState', ['setNameAlreadyInUseError']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../scss/mixins';

  .create-credentials {
  }

</style>
